export default __webpack_public_path__ + "static/media/MaterialCloth_04.6a2bfa6b.png";